import { api, ApiError } from "@/api/api";
import {
  EpisodeSummarized,
  GridRequestQueryParams
} from "@/api/episodes-types";
import { PaginatedData, QueryModels } from "@/api/utils";
import { useUser } from "@/queries/auth";
import { prepareQueryParams } from "@/utils/prepare-query-params";
import { useQuery } from "@tanstack/react-query";

export function useEpisodes(queryModels: QueryModels) {
  const { data: user } = useUser();
  const query = prepareQueryParams(queryModels) as GridRequestQueryParams;

  return useQuery<PaginatedData<EpisodeSummarized>, ApiError>({
    queryKey: ["GET", "episodes", queryModels],
    queryFn: () => api.episodes.get(query),
    enabled: !!user,
  });
}
